#import "../fragments/contact-audience-memberships.graphql"

query GetContactAudienceMemberships($personId: ID!) {
    contact(id: $personId) {
        ...ContactAudienceMeberships
    }
}
